/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Stat_ThemeInputs */

const tr_landing_shortcuts_stat_theme = /** @type {(inputs: Landing_Shortcuts_Stat_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`koyu / açık / sistem modu`)
};

const en_landing_shortcuts_stat_theme = /** @type {(inputs: Landing_Shortcuts_Stat_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dark / light / system mode`)
};

const de_landing_shortcuts_stat_theme = /** @type {(inputs: Landing_Shortcuts_Stat_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dunkel / Hell / Systemmodus`)
};

const ru_landing_shortcuts_stat_theme = /** @type {(inputs: Landing_Shortcuts_Stat_ThemeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`тёмная / светлая / системная тема`)
};

/**
* | output |
* | --- |
* | "dark / light / system mode" |
*
* @param {Landing_Shortcuts_Stat_ThemeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_stat_theme = /** @type {((inputs?: Landing_Shortcuts_Stat_ThemeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Stat_ThemeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_stat_theme(inputs)
	if (locale === "de") return de_landing_shortcuts_stat_theme(inputs)
	if (locale === "ru") return ru_landing_shortcuts_stat_theme(inputs)
	return tr_landing_shortcuts_stat_theme(inputs)
});